export const DIVISION_ORDER = ['beginner', 'junior', 'intermediate', 'experienced'];
